"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4774],{

/***/ 93877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ Filters; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(80822);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(69417);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js
var Container = __webpack_require__(46574);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityClose.js
var Icon24UtilityClose = __webpack_require__(82843);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/hooks/useActiveTheme.js
var useActiveTheme = __webpack_require__(56721);
// EXTERNAL MODULE: ./src/utils/filtersStorage.ts
var filtersStorage = __webpack_require__(85627);
// EXTERNAL MODULE: ./src/__generated__/globalTypes.ts
var globalTypes = __webpack_require__(79967);
// EXTERNAL MODULE: ./src/lib/analyticsHelper.tsx
var analyticsHelper = __webpack_require__(883);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
// EXTERNAL MODULE: ./src/components/contexts/SegmentationFiltersContext.tsx
var SegmentationFiltersContext = __webpack_require__(99207);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Selector/Selector.js
var Selector = __webpack_require__(35740);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Pill/Pill.js
var Pill = __webpack_require__(26929);
// EXTERNAL MODULE: ./node_modules/@mui/material/Accordion/Accordion.js + 3 modules
var Accordion = __webpack_require__(82280);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionSummary/AccordionSummary.js + 1 modules
var AccordionSummary = __webpack_require__(38895);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionDetails/AccordionDetails.js + 1 modules
var AccordionDetails = __webpack_require__(22797);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityChevron.js
var Icon24UtilityChevron = __webpack_require__(68720);
;// CONCATENATED MODULE: ./src/components/Filters/MultiSelectPills.tsx






var MultiSelectPills = function(param) {
    var handleOnChangeEvent = param.handleOnChangeEvent, selectedValues = param.selectedValues, pillOptions = param.pillOptions, category = param.category, sectionName = param.sectionName;
    var isEmbraceTheme = (0,useActiveTheme/* default */.Z)().isEmbraceTheme;
    var localStorageFilters = (0,filtersStorage/* loadFilters */.dm)();
    var isMobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var seniorCareProfessionalSkillsMap = {
        CERTIFIED_NURSING_ASSISTANT: "certifiedNursingAssistant",
        SENIOR_CARE_CPR_TRAINED: "seniorCareCprTrained",
        HOME_HEALTH_AIDE: "homeHealthAid",
        REGISTERED_NURSE: "registeredNurse"
    };
    var preferencesMap = {
        COMFORTABLE_WITH_PETS: "comfortableWithPets",
        HAS_CAR: "hasCar",
        NON_SMOKER: "nonSmoker"
    };
    // select all pill options that are currently in local storage
    var isSelected = function(value, section) {
        switch(section){
            case "SENIOR_CARE_CAN_HELP_WITH":
                var ref;
                return localStorageFilters === null || localStorageFilters === void 0 ? void 0 : (ref = localStorageFilters.seniorCareSubServices) === null || ref === void 0 ? void 0 : ref.includes(value);
            case "SENIOR_CARE_PROFESSIONAL_SKILLS":
                var ref1;
                return (localStorageFilters === null || localStorageFilters === void 0 ? void 0 : localStorageFilters[seniorCareProfessionalSkillsMap[value]]) || value === globalTypes/* SEOSeniorCareSubServices.DEMENTIA */.ze.DEMENTIA && (localStorageFilters === null || localStorageFilters === void 0 ? void 0 : (ref1 = localStorageFilters.seniorCareSubServices) === null || ref1 === void 0 ? void 0 : ref1.includes(globalTypes/* SEOSeniorCareSubServices.DEMENTIA */.ze.DEMENTIA));
            case "PREFERENCES":
                return localStorageFilters === null || localStorageFilters === void 0 ? void 0 : localStorageFilters[preferencesMap[value]];
            case "LANGUAGES_SPOKEN":
                var ref2;
                return localStorageFilters === null || localStorageFilters === void 0 ? void 0 : (ref2 = localStorageFilters.languages) === null || ref2 === void 0 ? void 0 : ref2.includes(value);
            case "CHILD_AGE_RANGES":
                var ref3;
                return localStorageFilters === null || localStorageFilters === void 0 ? void 0 : (ref3 = localStorageFilters.childCareAgeGroups) === null || ref3 === void 0 ? void 0 : ref3.includes(value);
            case "CHILD_CARE_PROFESSIONAL_SKILLS":
                var ref4;
                return localStorageFilters === null || localStorageFilters === void 0 ? void 0 : (ref4 = localStorageFilters.childCareQualifications) === null || ref4 === void 0 ? void 0 : ref4.includes(value);
            case "HOME_CARE_CAN_HELP_WITH":
                var ref5;
                return localStorageFilters === null || localStorageFilters === void 0 ? void 0 : (ref5 = localStorageFilters.housekeepingSubServices) === null || ref5 === void 0 ? void 0 : ref5.includes(value);
            default:
                return false;
        }
    };
    var pills = /*#__PURE__*/ (0,jsx_runtime.jsx)(Selector/* default */.Z, {
        onChange: function(values) {
            return handleOnChangeEvent(values);
        },
        horizontal: true,
        value: selectedValues,
        name: category,
        sx: function(theme) {
            return {
                "& > li": {
                    margin: theme.spacing(0.5, 1, 0.5, 0)
                }
            };
        },
        children: pillOptions.map(function(param) {
            var label = param.label, value = param.value;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Pill/* default */.Z, {
                label: label,
                value: value,
                selected: isSelected(value, category),
                sx: {
                    "& label": {
                        borderRadius: isEmbraceTheme ? 6 : undefined
                    }
                }
            }, value);
        })
    });
    var mobileView = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mb: 1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h3",
                    children: sectionName
                })
            }),
            pills
        ]
    });
    var desktopView = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
        elevation: 0,
        defaultExpanded: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
                expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityChevron/* default */.Z, {}),
                sx: {
                    padding: 0,
                    width: "fit-content"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h3",
                    mr: 1,
                    children: sectionName
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                sx: function(theme) {
                    return {
                        padding: theme.spacing(0, 0, 0, 0.5)
                    };
                },
                children: pills
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        component: "section",
        mb: 2,
        children: isMobile ? mobileView : desktopView
    });
};


;// CONCATENATED MODULE: ./src/components/Filters/Verticals/SeniorCare/CanHelpWith.tsx



var CanHelpWith = function(param) {
    var canHelpWithServices = param.canHelpWithServices, setCanHelpWithServices = param.setCanHelpWithServices;
    var seniorCareSubServicesOptions = [
        {
            label: "Companionship",
            value: globalTypes/* SEOSeniorCareSubServices.COMPANIONSHIP */.ze.COMPANIONSHIP
        },
        {
            label: "Mobility assistance",
            value: globalTypes/* SEOSeniorCareSubServices.MOBILITY_ASSISTANCE */.ze.MOBILITY_ASSISTANCE
        },
        {
            label: "Personal care",
            value: globalTypes/* SEOSeniorCareSubServices.PERSONAL_CARE */.ze.PERSONAL_CARE
        },
        {
            label: "Specialized care",
            value: globalTypes/* SEOSeniorCareSubServices.SPECIALIZED_CARE */.ze.SPECIALIZED_CARE
        },
        {
            label: "Transportation",
            value: globalTypes/* SEOSeniorCareSubServices.TRANSPORTATION */.ze.TRANSPORTATION
        }, 
    ];
    var handleOnChangeEvent = function(values) {
        // Dementia exists under "Professional skills" section on the UI, but is added to seniorCareSubServices
        if (canHelpWithServices && canHelpWithServices.includes(globalTypes/* SEOSeniorCareSubServices.DEMENTIA */.ze.DEMENTIA)) {
            setCanHelpWithServices(values.concat(globalTypes/* SEOSeniorCareSubServices.DEMENTIA */.ze.DEMENTIA));
        } else {
            setCanHelpWithServices(values);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiSelectPills, {
        sectionName: "Can help with",
        handleOnChangeEvent: handleOnChangeEvent,
        pillOptions: seniorCareSubServicesOptions,
        category: "SENIOR_CARE_CAN_HELP_WITH",
        selectedValues: canHelpWithServices || []
    });
};


// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Slider/Slider.js + 6 modules
var Slider = __webpack_require__(50734);
;// CONCATENATED MODULE: ./src/components/Filters/PayRate.tsx







var PayRate = function(param) {
    var hourlyRate = param.hourlyRate, setHourlyRate = param.setHourlyRate;
    var localStorageFilters = (0,filtersStorage/* loadFilters */.dm)();
    var isMobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    // check if hourlyRate filter is currently applied
    (0,react.useEffect)(function() {
        var currentHourlyRate = function() {
            var ref;
            var previousHourlyRate = localStorageFilters === null || localStorageFilters === void 0 ? void 0 : (ref = localStorageFilters.hourlyRate) === null || ref === void 0 ? void 0 : ref.split("-");
            if (previousHourlyRate && (previousHourlyRate === null || previousHourlyRate === void 0 ? void 0 : previousHourlyRate.length) === 2) {
                var _previousHourlyRate = (0,_sliced_to_array/* default */.Z)(previousHourlyRate, 2), previousMin = _previousHourlyRate[0], previousMax = _previousHourlyRate[1];
                return [
                    Number(previousMin),
                    Number(previousMax)
                ];
            }
            return hourlyRate;
        };
        setHourlyRate(currentHourlyRate());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handlePayRateChanges = function(val) {
        if (Array.isArray(val) && val.length === 2) {
            var _val = (0,_sliced_to_array/* default */.Z)(val, 2), minHourlyRate = _val[0], maxHourlyRate = _val[1];
            setHourlyRate([
                minHourlyRate,
                maxHourlyRate
            ]);
        }
    };
    var slider = /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        mt: 1,
        pl: 1,
        pr: 2.5,
        sx: {
            maxWidth: "327px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* default */.Z, {
            appendRange: true,
            max: 50,
            min: 10,
            step: 1,
            prefix: "$",
            unit: "hour",
            value: hourlyRate,
            onChange: handlePayRateChanges,
            "aria-label": "range-slider",
            sx: function(theme) {
                return {
                    "& .MuiSlider-root": {
                        padding: "13px 0"
                    },
                    "& span.bigLabel": {
                        marginLeft: theme.spacing(-1)
                    }
                };
            }
        })
    });
    var mobileView = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h3",
                children: "Pay rate"
            }),
            slider
        ]
    });
    var desktopView = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
        elevation: 0,
        defaultExpanded: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
                expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityChevron/* default */.Z, {}),
                sx: {
                    padding: 0,
                    width: "fit-content"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h3",
                    mr: 1,
                    children: "Pay rate"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                sx: function(theme) {
                    return {
                        padding: theme.spacing(0, 0, 0, 0.5)
                    };
                },
                children: slider
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        component: "section",
        mb: 2,
        children: isMobile ? mobileView : desktopView
    });
};


;// CONCATENATED MODULE: ./src/components/Filters/Verticals/SeniorCare/ProfessionalSkills.tsx





var ProfessionalSkills = function(param) {
    var setProfessionalSkillsObject = param.setProfessionalSkillsObject, seniorCareSubServices = param.seniorCareSubServices, setSeniorCareSubServices = param.setSeniorCareSubServices;
    var localStorageFilters = (0,filtersStorage/* loadFilters */.dm)();
    var CERTIFIED_NURSING_ASSISTANT = "CERTIFIED_NURSING_ASSISTANT";
    var SENIOR_CARE_CPR_TRAINED = "SENIOR_CARE_CPR_TRAINED";
    var HOME_HEALTH_AIDE = "HOME_HEALTH_AIDE";
    var REGISTERED_NURSE = "REGISTERED_NURSE";
    var DEMENTIA = globalTypes/* SEOSeniorCareSubServices.DEMENTIA */.ze.DEMENTIA;
    /*
   * The value of "Alzheimers/Dementia experience" currently does exist in our index.
   * Therefore, we are substituting its value for 'DEMENTIA' which exists in SEOSeniorCareSubServices
   */ var seniorCareProfessionalSkillsList = [
        {
            label: "Alzheimers/Dementia experience",
            value: DEMENTIA
        },
        {
            label: "Certified nursing assistant",
            value: CERTIFIED_NURSING_ASSISTANT
        },
        {
            label: "Cpr trained",
            value: SENIOR_CARE_CPR_TRAINED
        },
        {
            label: "Home health aide",
            value: HOME_HEALTH_AIDE
        },
        {
            label: "Registered nurse",
            value: REGISTERED_NURSE
        }, 
    ];
    var ref = (0,react.useState)([]), professionalSkillsList = ref[0], setProfessionalSkillsList = ref[1];
    // check if any professional skill filters are currently applied from local storage
    (0,react.useEffect)(function() {
        var ref;
        var currentProfessionalSkills = {
            certifiedNursingAssistant: false,
            seniorCareCprTrained: false,
            homeHealthAid: false,
            registeredNurse: false
        };
        var currentProfessionalSkillsList = [];
        if (localStorageFilters === null || localStorageFilters === void 0 ? void 0 : localStorageFilters.certifiedNursingAssistant) {
            currentProfessionalSkills.certifiedNursingAssistant = true;
            currentProfessionalSkillsList.push(CERTIFIED_NURSING_ASSISTANT);
        }
        if (localStorageFilters === null || localStorageFilters === void 0 ? void 0 : localStorageFilters.seniorCareCprTrained) {
            currentProfessionalSkills.seniorCareCprTrained = true;
            currentProfessionalSkillsList.push(SENIOR_CARE_CPR_TRAINED);
        }
        if (localStorageFilters === null || localStorageFilters === void 0 ? void 0 : localStorageFilters.homeHealthAid) {
            currentProfessionalSkills.homeHealthAid = true;
            currentProfessionalSkillsList.push(HOME_HEALTH_AIDE);
        }
        if (localStorageFilters === null || localStorageFilters === void 0 ? void 0 : localStorageFilters.registeredNurse) {
            currentProfessionalSkills.registeredNurse = true;
            currentProfessionalSkillsList.push(REGISTERED_NURSE);
        }
        if (localStorageFilters === null || localStorageFilters === void 0 ? void 0 : (ref = localStorageFilters.seniorCareSubServices) === null || ref === void 0 ? void 0 : ref.includes(DEMENTIA)) {
            currentProfessionalSkillsList.push(DEMENTIA);
        }
        setProfessionalSkillsObject(currentProfessionalSkills);
        setProfessionalSkillsList(currentProfessionalSkillsList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handleOnChangeEvent = function(values) {
        var professionalSkillsFilters = {
            certifiedNursingAssistant: false,
            seniorCareCprTrained: false,
            homeHealthAid: false,
            registeredNurse: false
        };
        values.forEach(function(skill) {
            switch(skill){
                case CERTIFIED_NURSING_ASSISTANT:
                    professionalSkillsFilters.certifiedNursingAssistant = true;
                    break;
                case SENIOR_CARE_CPR_TRAINED:
                    professionalSkillsFilters.seniorCareCprTrained = true;
                    break;
                case HOME_HEALTH_AIDE:
                    professionalSkillsFilters.homeHealthAid = true;
                    break;
                case REGISTERED_NURSE:
                    professionalSkillsFilters.registeredNurse = true;
                    break;
                case DEMENTIA:
                    if (!seniorCareSubServices || seniorCareSubServices.length < 1) {
                        setSeniorCareSubServices([
                            DEMENTIA
                        ]);
                    } else if (seniorCareSubServices && !seniorCareSubServices.includes(DEMENTIA)) {
                        var subServices = seniorCareSubServices.slice();
                        subServices.push(DEMENTIA);
                        setSeniorCareSubServices(subServices);
                    }
                    break;
                default:
            }
        });
        // remove Dementia from subservices if it has not been selected
        if (!values.includes(DEMENTIA) && (seniorCareSubServices === null || seniorCareSubServices === void 0 ? void 0 : seniorCareSubServices.includes(DEMENTIA))) {
            var subServices = seniorCareSubServices.slice();
            var index = seniorCareSubServices.indexOf(DEMENTIA);
            subServices.splice(index, 1);
            setSeniorCareSubServices(subServices);
        }
        setProfessionalSkillsList(values);
        setProfessionalSkillsObject(professionalSkillsFilters);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiSelectPills, {
        sectionName: "Professional skills",
        handleOnChangeEvent: handleOnChangeEvent,
        pillOptions: seniorCareProfessionalSkillsList,
        category: "SENIOR_CARE_PROFESSIONAL_SKILLS",
        selectedValues: professionalSkillsList
    });
};


;// CONCATENATED MODULE: ./src/components/Filters/Preferences.tsx




var Preferences = function(param) {
    var setPreferencesObject = param.setPreferencesObject;
    var localStorageFilters = (0,filtersStorage/* loadFilters */.dm)();
    var COMFORTABLE_WITH_PETS = "COMFORTABLE_WITH_PETS";
    var HAS_CAR = "HAS_CAR";
    var NON_SMOKER = "NON_SMOKER";
    var preferenceOptions = [
        {
            label: "Comfortable with pets",
            value: COMFORTABLE_WITH_PETS
        },
        {
            label: "Has own transportation",
            value: HAS_CAR
        },
        {
            label: "Non-smoker",
            value: NON_SMOKER
        }, 
    ];
    var ref = (0,react.useState)([]), preferencesList = ref[0], setPreferencesList = ref[1];
    // check if any preference filters are currently applied from local storage
    (0,react.useEffect)(function() {
        var localStoragePreferencesFilters = {
            comfortableWithPets: false,
            hasCar: false,
            nonSmoker: false
        };
        var currentPreferencesList = [];
        if (localStorageFilters === null || localStorageFilters === void 0 ? void 0 : localStorageFilters.comfortableWithPets) {
            localStoragePreferencesFilters.comfortableWithPets = true;
            currentPreferencesList.push(COMFORTABLE_WITH_PETS);
        }
        if (localStorageFilters === null || localStorageFilters === void 0 ? void 0 : localStorageFilters.hasCar) {
            localStoragePreferencesFilters.hasCar = true;
            currentPreferencesList.push(HAS_CAR);
        }
        if (localStorageFilters === null || localStorageFilters === void 0 ? void 0 : localStorageFilters.nonSmoker) {
            localStoragePreferencesFilters.nonSmoker = true;
            currentPreferencesList.push(NON_SMOKER);
        }
        setPreferencesObject(localStoragePreferencesFilters);
        setPreferencesList(currentPreferencesList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handleOnChangeEvent = function(values) {
        var preferencesFilters = {
            comfortableWithPets: false,
            hasCar: false,
            nonSmoker: false
        };
        values.forEach(function(skill) {
            switch(skill){
                case COMFORTABLE_WITH_PETS:
                    preferencesFilters.comfortableWithPets = true;
                    break;
                case HAS_CAR:
                    preferencesFilters.hasCar = true;
                    break;
                case NON_SMOKER:
                    preferencesFilters.nonSmoker = true;
                    break;
                default:
            }
        });
        setPreferencesObject(preferencesFilters);
        setPreferencesList(values);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiSelectPills, {
        sectionName: "Preferences",
        handleOnChangeEvent: handleOnChangeEvent,
        pillOptions: preferenceOptions,
        category: "PREFERENCES",
        selectedValues: preferencesList
    });
};


;// CONCATENATED MODULE: ./src/components/Filters/LanguagesSpoken.tsx



var LanguagesSpoken = function(param) {
    var languagesSpoken = param.languagesSpoken, setLanguagesSpoken = param.setLanguagesSpoken;
    var languagesList = [
        {
            label: "American Sign Language",
            value: globalTypes/* Language.SIGN_LANGUAGE_ASL */.SQ.SIGN_LANGUAGE_ASL
        },
        {
            label: "Arabic",
            value: globalTypes/* Language.ARABIC */.SQ.ARABIC
        },
        {
            label: "Chinese (Mandarin)",
            value: globalTypes/* Language.CHINESE */.SQ.CHINESE
        },
        {
            label: "English",
            value: globalTypes/* Language.ENGLISH */.SQ.ENGLISH
        },
        {
            label: "French",
            value: globalTypes/* Language.FRENCH */.SQ.FRENCH
        },
        {
            label: "German",
            value: globalTypes/* Language.GERMAN */.SQ.GERMAN
        },
        {
            label: "Hindi",
            value: globalTypes/* Language.HINDI */.SQ.HINDI
        },
        {
            label: "Japanese",
            value: globalTypes/* Language.JAPANESE */.SQ.JAPANESE
        },
        {
            label: "Korean",
            value: globalTypes/* Language.KOREAN */.SQ.KOREAN
        },
        {
            label: "Portuguese",
            value: globalTypes/* Language.PORTUGUESE */.SQ.PORTUGUESE
        },
        {
            label: "Russian",
            value: globalTypes/* Language.RUSSIAN */.SQ.RUSSIAN
        },
        {
            label: "Spanish",
            value: globalTypes/* Language.SPANISH */.SQ.SPANISH
        },
        {
            label: "Tagalog",
            value: globalTypes/* Language.TAGALOG */.SQ.TAGALOG
        }, 
    ];
    var handleOnChangeEvent = function(values) {
        setLanguagesSpoken(values);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiSelectPills, {
        sectionName: "Languages spoken",
        handleOnChangeEvent: handleOnChangeEvent,
        pillOptions: languagesList,
        category: "LANGUAGES_SPOKEN",
        selectedValues: languagesSpoken || []
    });
};


;// CONCATENATED MODULE: ./src/components/Filters/Verticals/SeniorCare/SeniorCareFilters.tsx






var SeniorCareFilters = function(param) {
    var hourlyRate = param.hourlyRate, setHourlyRate = param.setHourlyRate, seniorCareSubServices = param.seniorCareSubServices, setSeniorCareSubServices = param.setSeniorCareSubServices, setProfessionalSkillsObject = param.setProfessionalSkillsObject, setPreferencesObject = param.setPreferencesObject, languagesSpoken = param.languagesSpoken, setLanguagesSpoken = param.setLanguagesSpoken;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PayRate, {
                hourlyRate: hourlyRate,
                setHourlyRate: setHourlyRate
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CanHelpWith, {
                canHelpWithServices: seniorCareSubServices,
                setCanHelpWithServices: setSeniorCareSubServices
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfessionalSkills, {
                setProfessionalSkillsObject: setProfessionalSkillsObject,
                seniorCareSubServices: seniorCareSubServices,
                setSeniorCareSubServices: setSeniorCareSubServices
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Preferences, {
                setPreferencesObject: setPreferencesObject
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguagesSpoken, {
                languagesSpoken: languagesSpoken,
                setLanguagesSpoken: setLanguagesSpoken
            })
        ]
    });
};


;// CONCATENATED MODULE: ./src/components/Filters/Verticals/PetCare/PetCareFilters.tsx


var PetCareFilters = function(param) {
    var hourlyRate = param.hourlyRate, setHourlyRate = param.setHourlyRate;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PayRate, {
        hourlyRate: hourlyRate,
        setHourlyRate: setHourlyRate
    });
};


// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/StepperInput/StepperInput.js + 4 modules
var StepperInput = __webpack_require__(62473);
;// CONCATENATED MODULE: ./src/components/Filters/Verticals/ChildCare/NumberOfChildren.tsx




var NumberOfChildren = function(param) {
    var numberOfChildren = param.numberOfChildren, setNumberOfChildren = param.setNumberOfChildren;
    var isExtraSmallOrSmallViewport = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var isMediumOrLargerViewport = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.up("md");
    });
    var childOrChildren = numberOfChildren < 2 ? "Child" : "Children";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        component: "section",
        mb: 2,
        children: [
            isExtraSmallOrSmallViewport && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h3",
                        children: "Number of children"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StepperInput/* default */.Z, {
                        name: "number-of-children-stepper-input",
                        stepperLabel: childOrChildren,
                        initialVal: numberOfChildren,
                        min: 1,
                        max: 5,
                        layout: "horizontal",
                        maxInputSuffix: true,
                        onChange: setNumberOfChildren
                    })
                ]
            }),
            isMediumOrLargerViewport && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
                elevation: 0,
                defaultExpanded: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
                        expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityChevron/* default */.Z, {}),
                        sx: {
                            padding: 0,
                            width: "fit-content"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h3",
                            mr: 1,
                            children: "Number of children"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                        sx: function(theme) {
                            return {
                                padding: theme.spacing(0, 0, 0, 0.5)
                            };
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StepperInput/* default */.Z, {
                            name: "number-of-children-stepper-input",
                            stepperLabel: childOrChildren,
                            initialVal: numberOfChildren,
                            min: 1,
                            max: 5,
                            layout: "horizontal",
                            maxInputSuffix: true,
                            onChange: setNumberOfChildren,
                            sx: {
                                display: "flex",
                                "& label": {
                                    mr: 10
                                }
                            }
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Filters/Verticals/ChildCare/ChildAgeRanges.tsx



var ChildAgeRanges = function(param) {
    var childCareAgeGroupsList = param.childCareAgeGroupsList, setChildCareAgeGroupsList = param.setChildCareAgeGroupsList;
    var childCareAgeRangeList = [
        {
            label: "0 - 11 months",
            value: globalTypes/* ChildCareAgeGroups.NEWBORN */._$.NEWBORN
        },
        {
            label: "1 - 3 yrs",
            value: globalTypes/* ChildCareAgeGroups.TODDLER */._$.TODDLER
        },
        {
            label: "4 - 5 yrs",
            value: globalTypes/* ChildCareAgeGroups.EARLY_SCHOOL */._$.EARLY_SCHOOL
        },
        {
            label: "6 - 11 yrs",
            value: globalTypes/* ChildCareAgeGroups.ELEMENTARY_SCHOOL */._$.ELEMENTARY_SCHOOL
        },
        {
            label: "12+ yrs",
            value: globalTypes/* ChildCareAgeGroups.TEEN */._$.TEEN
        }, 
    ];
    var handleOnChangeEvent = function(values) {
        setChildCareAgeGroupsList(values);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiSelectPills, {
        sectionName: "Child age ranges",
        handleOnChangeEvent: handleOnChangeEvent,
        pillOptions: childCareAgeRangeList,
        category: "CHILD_AGE_RANGES",
        selectedValues: childCareAgeGroupsList
    });
};


;// CONCATENATED MODULE: ./src/components/Filters/Verticals/ChildCare/ProfessionalSkills.tsx



var ProfessionalSkills_ProfessionalSkills = function(param) {
    var childCareProfessionalSkillsList = param.childCareProfessionalSkillsList, setChildCareProfessionalSkillsList = param.setChildCareProfessionalSkillsList;
    var childCareProfessionalSkills = [
        {
            label: "CPR training",
            value: globalTypes/* SEOChildCareQualifications.CPR_TRAINING */.BY.CPR_TRAINING
        },
        {
            label: "First Aid training",
            value: globalTypes/* SEOChildCareQualifications.FIRST_AID_TRAINING */.BY.FIRST_AID_TRAINING
        },
        {
            label: "Special needs care",
            value: globalTypes/* SEOChildCareQualifications.SPECIAL_NEEDS_CARE */.BY.SPECIAL_NEEDS_CARE
        }, 
    ];
    var handleOnChangeEvent = function(values) {
        setChildCareProfessionalSkillsList(values);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiSelectPills, {
        sectionName: "Professional skills",
        handleOnChangeEvent: handleOnChangeEvent,
        pillOptions: childCareProfessionalSkills,
        category: "CHILD_CARE_PROFESSIONAL_SKILLS",
        selectedValues: childCareProfessionalSkillsList
    });
};


;// CONCATENATED MODULE: ./src/components/Filters/Verticals/ChildCare/ChildCareFilters.tsx







var ChildCareFilters = function(param) {
    var hourlyRate = param.hourlyRate, setHourlyRate = param.setHourlyRate, numberOfChildren = param.numberOfChildren, setNumberOfChildren = param.setNumberOfChildren, childCareAgeGroupsList = param.childCareAgeGroupsList, setChildCareAgeGroupsList = param.setChildCareAgeGroupsList, childCareProfessionalSkillsList = param.childCareProfessionalSkillsList, setChildCareProfessionalSkillsList = param.setChildCareProfessionalSkillsList, setPreferencesObject = param.setPreferencesObject, languagesSpoken = param.languagesSpoken, setLanguagesSpoken = param.setLanguagesSpoken;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PayRate, {
                hourlyRate: hourlyRate,
                setHourlyRate: setHourlyRate
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberOfChildren, {
                numberOfChildren: numberOfChildren,
                setNumberOfChildren: setNumberOfChildren
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildAgeRanges, {
                childCareAgeGroupsList: childCareAgeGroupsList,
                setChildCareAgeGroupsList: setChildCareAgeGroupsList
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfessionalSkills_ProfessionalSkills, {
                childCareProfessionalSkillsList: childCareProfessionalSkillsList,
                setChildCareProfessionalSkillsList: setChildCareProfessionalSkillsList
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Preferences, {
                setPreferencesObject: setPreferencesObject
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguagesSpoken, {
                languagesSpoken: languagesSpoken,
                setLanguagesSpoken: setLanguagesSpoken
            })
        ]
    });
};


;// CONCATENATED MODULE: ./src/components/Filters/utils/getAmplitudeFilters.ts


var ALZHEIMERS_DEMENTIA_EXPERIENCE = "ALZHEIMERS_DEMENTIA_EXPERIENCE";
var CERTIFIED_NURSING_ASSISTANT = "CERTIFIED_NURSING_ASSISTANT";
var SENIOR_CARE_CPR_TRAINED = "SENIOR_CARE_CPR_TRAINED";
var HOME_HEALTH_AIDE = "HOME_HEALTH_AIDE";
var REGISTERED_NURSE = "REGISTERED_NURSE";
var COMFORTABLE_WITH_PETS = "COMFORTABLE_WITH_PETS";
var HAS_CAR = "HAS_CAR";
var NON_SMOKER = "NON_SMOKER";
var getAmplitudeFilters = function(filters, vertical) {
    var amplitudeFilters = {
        feature_name: "Filters Applied"
    };
    var preferencesList = [];
    var professionalSkillsList = [];
    switch(vertical){
        case "SENIOR_CARE":
            var ref;
            // set 'can_help_with'
            if (filters === null || filters === void 0 ? void 0 : (ref = filters.seniorCareSubServices) === null || ref === void 0 ? void 0 : ref.includes(globalTypes/* SEOSeniorCareSubServices.DEMENTIA */.ze.DEMENTIA)) {
                // Remove 'Dementia' from 'can_help_with'
                var canHelpWith = filters.seniorCareSubServices.slice();
                var index = canHelpWith.indexOf(globalTypes/* SEOSeniorCareSubServices.DEMENTIA */.ze.DEMENTIA);
                canHelpWith.splice(index, 1);
                // Add 'Alzheimers/Dementia experience' to 'professionalSkillsList'
                professionalSkillsList.push(ALZHEIMERS_DEMENTIA_EXPERIENCE);
                if (canHelpWith.length > 0) {
                    amplitudeFilters.can_help_with = canHelpWith.join(", ");
                }
            } else if ((filters === null || filters === void 0 ? void 0 : filters.seniorCareSubServices) && filters.seniorCareSubServices.length > 0) {
                amplitudeFilters.can_help_with = filters.seniorCareSubServices.join(", ");
            }
            // set 'professional_skills' for Senior Care vertical
            if (filters === null || filters === void 0 ? void 0 : filters.certifiedNursingAssistant) {
                professionalSkillsList.push(CERTIFIED_NURSING_ASSISTANT);
            }
            if (filters === null || filters === void 0 ? void 0 : filters.seniorCareCprTrained) {
                professionalSkillsList.push(SENIOR_CARE_CPR_TRAINED);
            }
            if (filters === null || filters === void 0 ? void 0 : filters.homeHealthAid) {
                professionalSkillsList.push(HOME_HEALTH_AIDE);
            }
            if (filters === null || filters === void 0 ? void 0 : filters.registeredNurse) {
                professionalSkillsList.push(REGISTERED_NURSE);
            }
            if (professionalSkillsList.length > 0) {
                amplitudeFilters.professional_skills = professionalSkillsList.join(", ");
            }
            break;
        case "CHILD_CARE":
            // set 'number_of_children'
            if (filters === null || filters === void 0 ? void 0 : filters.numberOfChildren) {
                amplitudeFilters.number_of_children = filters.numberOfChildren;
            }
            // set 'child_age_ranges'
            if ((filters === null || filters === void 0 ? void 0 : filters.childCareAgeGroups) && filters.childCareAgeGroups.length > 0) {
                amplitudeFilters.child_age_ranges = filters.childCareAgeGroups.join(", ");
            }
            // set 'professional_skills' for Child Care vertical
            if ((filters === null || filters === void 0 ? void 0 : filters.childCareQualifications) && filters.childCareQualifications.length > 0) {
                amplitudeFilters.professional_skills = filters.childCareQualifications.join(", ");
            }
            break;
        case "HOME_CARE":
            // set 'can_help_with' for Home Care vertical
            if (filters === null || filters === void 0 ? void 0 : filters.housekeepingSubServices) {
                amplitudeFilters.can_help_with = filters.housekeepingSubServices.join(", ");
            }
            break;
        default:
    }
    // set 'min_rate' and 'max_rate'
    if (filters === null || filters === void 0 ? void 0 : filters.hourlyRate) {
        var ref1 = (0,_sliced_to_array/* default */.Z)(filters.hourlyRate.split("-"), 2), minHourlyRate = ref1[0], maxHourlyRate = ref1[1];
        amplitudeFilters.min_rate = Number(minHourlyRate);
        amplitudeFilters.max_rate = Number(maxHourlyRate);
    }
    // set 'preferences' for Senior Care and Child Care verticals
    if (filters === null || filters === void 0 ? void 0 : filters.comfortableWithPets) {
        preferencesList.push(COMFORTABLE_WITH_PETS);
    }
    if (filters === null || filters === void 0 ? void 0 : filters.hasCar) {
        preferencesList.push(HAS_CAR);
    }
    if (filters === null || filters === void 0 ? void 0 : filters.nonSmoker) {
        preferencesList.push(NON_SMOKER);
    }
    if (preferencesList.length > 0) {
        amplitudeFilters.preferences = preferencesList.join(", ");
    }
    // set 'languages_spoken'
    if ((filters === null || filters === void 0 ? void 0 : filters.languages) && filters.languages.length > 0) {
        amplitudeFilters.languages_spoken = filters.languages.join(", ");
    }
    return amplitudeFilters;
};


// EXTERNAL MODULE: ./src/components/contexts/PageAttributesContext.tsx
var PageAttributesContext = __webpack_require__(73739);
;// CONCATENATED MODULE: ./src/components/Filters/Verticals/HomeCare/CanHelpWith.tsx



var CanHelpWith_CanHelpWith = function(param) {
    var canHelpWithServices = param.canHelpWithServices, setCanHelpWithServices = param.setCanHelpWithServices;
    var homeCareSubServicesOptions = [
        {
            label: "Bathroom cleaning",
            value: globalTypes/* HousekeepingService.BATHROOM_CLEANING */.gg.BATHROOM_CLEANING
        },
        {
            label: "Carpet cleaning",
            value: globalTypes/* HousekeepingService.CARPET_CLEANING */.gg.CARPET_CLEANING
        },
        {
            label: "Kitchen cleaning",
            value: globalTypes/* HousekeepingService.KITCHEN_CLEANING */.gg.KITCHEN_CLEANING
        },
        {
            label: "Laundry",
            value: globalTypes/* HousekeepingService.LAUNDRY */.gg.LAUNDRY
        },
        {
            label: "Window cleaning",
            value: globalTypes/* HousekeepingService.WINDOW_WASHING */.gg.WINDOW_WASHING
        }, 
    ];
    var handleOnChangeEvent = function(values) {
        setCanHelpWithServices(values);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiSelectPills, {
        sectionName: "Can help with",
        handleOnChangeEvent: handleOnChangeEvent,
        pillOptions: homeCareSubServicesOptions,
        category: "HOME_CARE_CAN_HELP_WITH",
        selectedValues: canHelpWithServices || []
    });
};


;// CONCATENATED MODULE: ./src/components/Filters/Verticals/HomeCare/HomeCareFilters.tsx



var HomeCareFilters = function(param) {
    var hourlyRate = param.hourlyRate, setHourlyRate = param.setHourlyRate, housekeepingSubServices = param.housekeepingSubServices, setHousekeepingSubServices = param.setHousekeepingSubServices;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PayRate, {
                hourlyRate: hourlyRate,
                setHourlyRate: setHourlyRate
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CanHelpWith_CanHelpWith, {
                canHelpWithServices: housekeepingSubServices,
                setCanHelpWithServices: setHousekeepingSubServices
            })
        ]
    });
};


;// CONCATENATED MODULE: ./src/components/Filters/Filters.tsx




















var Filters = function(param) {
    var setPopoverAnchorEl = param.setPopoverAnchorEl, setOpenFiltersPopover = param.setOpenFiltersPopover, setOpenFiltersModal = param.setOpenFiltersModal;
    var isEmbraceTheme = (0,useActiveTheme/* default */.Z)().isEmbraceTheme;
    var localStorageFilters = (0,filtersStorage/* loadFilters */.dm)();
    var ref = (0,SegmentationFiltersContext/* useSegmentationFiltersContext */.RZ)(), fetchResults = ref.fetchResults, filters = ref.filters;
    var isMobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var ref1 = (0,PageAttributesContext/* usePageAttributes */.l)(), searchingFor = ref1.searchingFor, serviceIdForMember = ref1.serviceIdForMember;
    var professionalSkillsOptions = {
        certifiedNursingAssistant: false,
        seniorCareCprTrained: false,
        homeHealthAid: false,
        registeredNurse: false
    };
    var preferencesOptions = {
        comfortableWithPets: false,
        hasCar: false,
        nonSmoker: false
    };
    var ref2 = (0,react.useState)([
        10,
        50
    ]), hourlyRate = ref2[0], setHourlyRate = ref2[1];
    var ref3 = (0,react.useState)((localStorageFilters === null || localStorageFilters === void 0 ? void 0 : localStorageFilters.seniorCareSubServices) || []), seniorCareSubServices = ref3[0], setSeniorCareSubServices = ref3[1];
    var ref4 = (0,react.useState)(professionalSkillsOptions), seniorCareProfessionalSkillsObject = ref4[0], setSeniorCareProfessionalSkillsObject = ref4[1];
    var ref5 = (0,react.useState)(preferencesOptions), preferencesObject = ref5[0], setPreferencesObject = ref5[1];
    var ref6 = (0,react.useState)((localStorageFilters === null || localStorageFilters === void 0 ? void 0 : localStorageFilters.languages) || []), languagesSpoken = ref6[0], setLanguagesSpoken = ref6[1];
    var ref7;
    var ref8 = (0,react.useState)((ref7 = localStorageFilters === null || localStorageFilters === void 0 ? void 0 : localStorageFilters.numberOfChildren) !== null && ref7 !== void 0 ? ref7 : 1), numberOfChildren = ref8[0], setNumberOfChildren = ref8[1];
    var ref9 = (0,react.useState)((localStorageFilters === null || localStorageFilters === void 0 ? void 0 : localStorageFilters.childCareAgeGroups) || []), childCareAgeGroupsList = ref9[0], setChildCareAgeGroupsList = ref9[1];
    var ref10 = (0,react.useState)((localStorageFilters === null || localStorageFilters === void 0 ? void 0 : localStorageFilters.childCareQualifications) || []), childCareProfessionalSkillsList = ref10[0], setChildCareProfessionalSkillsList = ref10[1];
    var ref11 = (0,react.useState)((localStorageFilters === null || localStorageFilters === void 0 ? void 0 : localStorageFilters.housekeepingSubServices) || []), housekeepingSubServices = ref11[0], setHousekeepingSubServices = ref11[1];
    var showPetCareUserFilters = searchingFor === globalTypes/* SEOSegmentationSearchingFor.PROVIDER */.yh.PROVIDER && serviceIdForMember === constants/* ServiceIdForMember.PET_CARE */.u2.PET_CARE;
    var showSeniorCareUserFilters = searchingFor === globalTypes/* SEOSegmentationSearchingFor.PROVIDER */.yh.PROVIDER && serviceIdForMember === constants/* ServiceIdForMember.SENIOR_CARE */.u2.SENIOR_CARE;
    var showChildCareUserFilters = (searchingFor === globalTypes/* SEOSegmentationSearchingFor.PROVIDER */.yh.PROVIDER || searchingFor === globalTypes/* SEOSegmentationSearchingFor.ALL_PROVIDER */.yh.ALL_PROVIDER) && (serviceIdForMember === constants/* ServiceIdForMember.CHILD_CARE */.u2.CHILD_CARE || serviceIdForMember === constants/* ServiceIdForMember.BABYSITTER */.u2.BABYSITTER || serviceIdForMember === constants/* ServiceIdForMember.NANNY */.u2.NANNY);
    var showHomeCareUserFilters = (searchingFor === globalTypes/* SEOSegmentationSearchingFor.PROVIDER */.yh.PROVIDER || searchingFor === globalTypes/* SEOSegmentationSearchingFor.ALL_PROVIDER */.yh.ALL_PROVIDER) && serviceIdForMember === constants/* ServiceIdForMember.HOUSEKEEPING */.u2.HOUSEKEEPING;
    var handleCloseButton = function() {
        if (setOpenFiltersPopover) {
            setOpenFiltersPopover(false);
        }
        if (setOpenFiltersModal) {
            setOpenFiltersModal(false);
        }
        if (setPopoverAnchorEl) {
            setPopoverAnchorEl(null);
        }
    };
    var handleResetClick = function() {
        var ref;
        (0,filtersStorage/* clearFilters */.K5)();
        fetchResults({
            zipcode: filters === null || filters === void 0 ? void 0 : (ref = filters.location) === null || ref === void 0 ? void 0 : ref.zipcode
        }, true);
        handleCloseButton();
    };
    var getCurrentFilters = function() {
        var _hourlyRate = (0,_sliced_to_array/* default */.Z)(hourlyRate, 2), minHourlyRate = _hourlyRate[0], maxHourlyRate = _hourlyRate[1];
        var currentHourlyRate = "".concat(minHourlyRate, "-").concat(maxHourlyRate);
        if (showPetCareUserFilters) {
            return {
                hourlyRate: currentHourlyRate
            };
        }
        if (showSeniorCareUserFilters) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                hourlyRate: currentHourlyRate,
                seniorCareSubServices: seniorCareSubServices
            }, seniorCareProfessionalSkillsObject, preferencesObject), {
                languages: languagesSpoken
            });
        }
        if (showChildCareUserFilters) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                hourlyRate: currentHourlyRate,
                numberOfChildren: numberOfChildren,
                childCareAgeGroups: childCareAgeGroupsList,
                childCareQualifications: childCareProfessionalSkillsList
            }, preferencesObject), {
                languages: languagesSpoken
            });
        }
        if (showHomeCareUserFilters) {
            return {
                hourlyRate: currentHourlyRate,
                housekeepingSubServices: housekeepingSubServices
            };
        }
        return {};
    };
    var getCurrentVertical = function() {
        if (showPetCareUserFilters) {
            return "PET_CARE";
        }
        if (showSeniorCareUserFilters) {
            return "SENIOR_CARE";
        }
        if (showChildCareUserFilters) {
            return "CHILD_CARE";
        }
        if (showHomeCareUserFilters) {
            return "HOME_CARE";
        }
        return "";
    };
    var handleApplyClick = function() {
        var ref;
        var currentFilters = getCurrentFilters();
        var currentVertical = getCurrentVertical();
        var amplitudeFilters = getAmplitudeFilters(currentFilters, currentVertical);
        // save filters to local storage
        (0,filtersStorage/* saveFilters */.HJ)(currentFilters);
        if (setPopoverAnchorEl) {
            setPopoverAnchorEl(null);
        }
        if (setOpenFiltersPopover) {
            setOpenFiltersPopover(false);
        }
        if (setOpenFiltersModal) {
            setOpenFiltersModal(false);
        }
        fetchResults((0,_object_spread/* default */.Z)({
            zipcode: filters === null || filters === void 0 ? void 0 : (ref = filters.location) === null || ref === void 0 ? void 0 : ref.zipcode
        }, currentFilters), true);
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoFeatureInteracted */.Sj.seoFeatureInteracted, amplitudeFilters);
    };
    var closeButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        mb: 3.5,
        textAlign: "right",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
            onClick: handleCloseButton,
            "aria-label": "filter-close-btn",
            "data-testid": "close-filters-button",
            size: "large",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityClose/* default */.Z, {})
        })
    });
    var applyButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        color: isEmbraceTheme ? "primary" : "secondary",
        variant: "contained",
        size: "large",
        sx: function(theme) {
            return {
                height: "40px",
                minWidth: {
                    xs: "100%",
                    sm: "327px"
                },
                margin: "0 auto",
                fontSize: theme.typography.body1.fontSize
            };
        },
        onClick: handleApplyClick,
        children: "Apply"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        maxWidth: "md",
        disableGutters: isMobile,
        sx: function(theme) {
            return (0,_define_property/* default */.Z)({
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between"
            }, theme.breakpoints.up("md"), {
                width: "100%",
                maxWidth: "578px",
                paddingTop: theme.spacing(2.5),
                paddingBottom: theme.spacing(2)
            });
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                direction: "column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        container: true,
                        item: true,
                        alignItems: "center",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                container: true,
                                item: true,
                                xs: 11,
                                alignItems: "center",
                                justifyContent: "space-between",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    mb: 3.5,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "h2",
                                            children: "Filters"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            color: "primary",
                                            size: "small",
                                            sx: {
                                                width: "60px"
                                            },
                                            onClick: handleResetClick,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: isEmbraceTheme ? "link2" : "body2",
                                                sx: (0,_object_spread/* default */.Z)({}, isEmbraceTheme && {
                                                    fontWeight: 500,
                                                    textDecoration: "underline",
                                                    alignSelf: "flex-end"
                                                }),
                                                children: "Reset"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 1,
                                children: closeButton
                            })
                        ]
                    }),
                    showPetCareUserFilters && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PetCareFilters, {
                            hourlyRate: hourlyRate,
                            setHourlyRate: setHourlyRate
                        })
                    }),
                    showSeniorCareUserFilters && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SeniorCareFilters, {
                            hourlyRate: hourlyRate,
                            setHourlyRate: setHourlyRate,
                            seniorCareSubServices: seniorCareSubServices,
                            setSeniorCareSubServices: setSeniorCareSubServices,
                            setProfessionalSkillsObject: setSeniorCareProfessionalSkillsObject,
                            setPreferencesObject: setPreferencesObject,
                            languagesSpoken: languagesSpoken,
                            setLanguagesSpoken: setLanguagesSpoken
                        })
                    }),
                    showChildCareUserFilters && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildCareFilters, {
                            hourlyRate: hourlyRate,
                            setHourlyRate: setHourlyRate,
                            numberOfChildren: numberOfChildren,
                            setNumberOfChildren: setNumberOfChildren,
                            childCareAgeGroupsList: childCareAgeGroupsList,
                            setChildCareAgeGroupsList: setChildCareAgeGroupsList,
                            childCareProfessionalSkillsList: childCareProfessionalSkillsList,
                            setChildCareProfessionalSkillsList: setChildCareProfessionalSkillsList,
                            setPreferencesObject: setPreferencesObject,
                            languagesSpoken: languagesSpoken,
                            setLanguagesSpoken: setLanguagesSpoken
                        })
                    }),
                    showHomeCareUserFilters && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeCareFilters, {
                            hourlyRate: hourlyRate,
                            setHourlyRate: setHourlyRate,
                            housekeepingSubServices: housekeepingSubServices,
                            setHousekeepingSubServices: setHousekeepingSubServices
                        })
                    })
                ]
            }),
            applyButton
        ]
    });
};



/***/ }),

/***/ 775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ FiltersCTA; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69417);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15861);
/* harmony import */ var _care_react_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70834);
/* harmony import */ var _care_react_component_lib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56721);
/* harmony import */ var _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(883);





var FiltersCTA = function(param) {
    var setOpenFiltersPopover = param.setOpenFiltersPopover, setOpenFiltersModal = param.setOpenFiltersModal, setPopoverAnchorEl = param.setPopoverAnchorEl;
    var isEmbraceTheme = (0,_care_react_component_lib__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().isEmbraceTheme;
    var handleFiltersCTAClick = function(event) {
        if (setOpenFiltersModal) {
            setOpenFiltersModal(true);
        }
        if (setOpenFiltersPopover) {
            setOpenFiltersPopover(true);
        }
        if (setPopoverAnchorEl) {
            setPopoverAnchorEl(event.currentTarget);
        }
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_1__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_1__/* .AmplitudeEvent.seoFeatureInteracted */ .Sj.seoFeatureInteracted, {
            feature_name: "Filters Viewed"
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        mb: {
            md: 6
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            variant: "outlined",
            size: "small",
            color: isEmbraceTheme ? "primary" : "secondary",
            onClick: handleFiltersCTAClick,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        pr: 1,
                        pt: 1,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_icons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        component: "span",
                        variant: "body1",
                        children: "Filter"
                    })
                ]
            })
        })
    });
};



/***/ }),

/***/ 88450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ FiltersModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _care_react_component_lib__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14721);
/* harmony import */ var _care_react_component_lib__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(387);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80822);
/* harmony import */ var _Filters__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93877);
/* harmony import */ var _FiltersCTA__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(775);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  0% {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var fadeInUp = (0,_mui_material__WEBPACK_IMPORTED_MODULE_5__/* .keyframes */ .F4)(_templateObject());
var FiltersModal = function(param) {
    var isVisible = param.isVisible;
    var animationDuration = 0.5;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), openFiltersModal = ref[0], setOpenFiltersModal = ref[1];
    var handleCloseModal = function() {
        setOpenFiltersModal(false);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                sx: {
                    background: "transparent"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    className: isVisible ? "show-filters-modal" : "hide-filters-modal",
                    sx: {
                        opacity: 0,
                        position: "relative",
                        "&.hide-filters-modal": {
                            animation: "none"
                        },
                        "&.show-filters-modal": {
                            animation: "".concat(fadeInUp, " ").concat(animationDuration, "s ease-out forwards")
                        }
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_FiltersCTA__WEBPACK_IMPORTED_MODULE_4__/* .FiltersCTA */ .b, {
                        setOpenFiltersModal: setOpenFiltersModal
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                open: openFiltersModal,
                onClose: handleCloseModal,
                hideClose: true,
                "aria-labelledby": "listing-page-filters-modal",
                sx: function(theme) {
                    return {
                        "& .MuiDialogContent-root": {
                            paddingBottom: 0
                        },
                        "& .MuiDialog-paper": (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, theme.breakpoints.down("md"), {
                            padding: theme.spacing(3),
                            margin: 0,
                            top: 0,
                            width: "100%",
                            minWidth: "unset",
                            maxWidth: "unset",
                            height: "100%",
                            maxHeight: "100%",
                            borderRadius: "0px"
                        })
                    };
                },
                variant: "dynamic",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Filters__WEBPACK_IMPORTED_MODULE_3__/* .Filters */ .x, {
                    setOpenFiltersModal: setOpenFiltersModal
                })
            })
        ]
    });
};



/***/ }),

/***/ 61166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ FiltersPopover; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14564);
/* harmony import */ var _care_react_component_lib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56721);
/* harmony import */ var _FiltersCTA__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(775);
/* harmony import */ var _Filters__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93877);






var FiltersPopover = function() {
    var isEmbraceTheme = (0,_care_react_component_lib__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().isEmbraceTheme;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), openFiltersPopover = ref[0], setOpenFiltersPopover = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), anchorEl = ref1[0], setAnchorEl = ref1[1];
    var handlePopoverClose = function() {
        setAnchorEl(null);
        setOpenFiltersPopover(false);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        mt: isEmbraceTheme ? 0 : 1,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FiltersCTA__WEBPACK_IMPORTED_MODULE_2__/* .FiltersCTA */ .b, {
                setOpenFiltersPopover: setOpenFiltersPopover,
                setPopoverAnchorEl: setAnchorEl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                id: "listing-page-filters-popover",
                open: openFiltersPopover,
                anchorEl: anchorEl,
                onClose: handlePopoverClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "left"
                },
                slotProps: {
                    paper: {
                        sx: {
                            borderRadius: isEmbraceTheme ? 8 : undefined
                        }
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    width: "559px",
                    maxHeight: "742px",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Filters__WEBPACK_IMPORTED_MODULE_3__/* .Filters */ .x, {
                        setPopoverAnchorEl: setAnchorEl,
                        setOpenFiltersPopover: setOpenFiltersPopover
                    })
                })
            })
        ]
    });
};



/***/ }),

/***/ 6150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ SafetyModalWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _care_caregiver_profile_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1958);
/* harmony import */ var _generated_globalTypes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79967);
/* harmony import */ var _utils_getZipcodeFromGeoInfo__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7360);
/* harmony import */ var _contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73739);
/* harmony import */ var _hooks_useZipCodeValidation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89698);









var SafetyModalWrapper = function(param) {
    var openModal = param.openModal, setOpenModal = param.setOpenModal, _isCaregiverProfilePage = param.isCaregiverProfilePage, isCaregiverProfilePage = _isCaregiverProfilePage === void 0 ? false : _isCaregiverProfilePage, _caregiverStateCode = param.caregiverStateCode, caregiverStateCode = _caregiverStateCode === void 0 ? null : _caregiverStateCode;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isFromMassachusetts = ref[0], setIsFromMassachusetts = ref[1];
    var ref1 = (0,_contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_3__/* .usePageAttributes */ .l)(), userGeoInfo = ref1.userGeoInfo, seoSegmentId = ref1.seoSegmentId;
    var validate = (0,_hooks_useZipCodeValidation__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().validate;
    var getStateCodeFromSegmentId = function(segmentId) {
        var segment = segmentId.split("/").pop();
        if (segment === null || segment === void 0 ? void 0 : segment.includes("-")) {
            var state = segment.split("-").pop();
            var ref;
            return (ref = state === null || state === void 0 ? void 0 : state.toUpperCase()) !== null && ref !== void 0 ? ref : null;
        }
        return null;
    };
    var stateCodeFromSegmentId = getStateCodeFromSegmentId(seoSegmentId);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var fetchStateLocation = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                var zipCode, data;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            zipCode = (0,_utils_getZipcodeFromGeoInfo__WEBPACK_IMPORTED_MODULE_7__/* .getZipcodeFromGeoInfo */ .Z)(userGeoInfo);
                            return [
                                4,
                                validate(zipCode)
                            ];
                        case 1:
                            data = _state.sent();
                            if ((data === null || data === void 0 ? void 0 : data.state) === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_2__/* .UsStateCode.MA */ .y9.MA) {
                                setIsFromMassachusetts(true);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchStateLocation() {
                return _ref.apply(this, arguments);
            };
        }();
        if (isCaregiverProfilePage) {
            setIsFromMassachusetts(caregiverStateCode === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_2__/* .UsStateCode.MA */ .y9.MA);
        } else {
            setIsFromMassachusetts(stateCodeFromSegmentId === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_2__/* .UsStateCode.MA */ .y9.MA);
        }
        fetchStateLocation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_caregiver_profile_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        open: openModal,
        onClose: function() {
            return setOpenModal(false);
        },
        newSafetyExperienceEnabled: true,
        isMAProviderOrSeeker: isFromMassachusetts
    });
};



/***/ }),

/***/ 97254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* binding */ IterableBannerSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/common/IterableWrapper.tsx
var IterableWrapper = __webpack_require__(25153);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@care/iterable-display/dist/index.js + 16 modules
var dist = __webpack_require__(46207);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(80822);
// EXTERNAL MODULE: ./src/lib/analyticsHelper.tsx
var analyticsHelper = __webpack_require__(883);
// EXTERNAL MODULE: ./src/components/hooks/useFeatureFlag.ts
var useFeatureFlag = __webpack_require__(19500);
;// CONCATENATED MODULE: ./src/components/common/IterableBanner.tsx







var ref;
var getIterableAmplitudeData = function(message) {
    var ref1, ref2;
    return {
        messageId: message.metadata.messageId,
        campaignId: message.metadata.campaignId,
        placementId: message.metadata.placementId,
        campaign: (ref1 = message.payload) === null || ref1 === void 0 ? void 0 : ref1.campaign,
        assetLocation: "VHP",
        assetText: (ref = (ref2 = message.elements) === null || ref2 === void 0 ? void 0 : ref2.body) !== null && ref !== void 0 ? ref : /* istanbul ignore next */ "",
        assetType: "banner"
    };
};
var IterableBanner = function(param) {
    var placementId = param.placementId, slotProps = param.slotProps;
    var iterableCampaignFlag = (0,useFeatureFlag/* default */.Z)("visitor-iterable-campaign-active");
    var isIterableCampaignActive = (iterableCampaignFlag === null || iterableCampaignFlag === void 0 ? void 0 : iterableCampaignFlag.value) === true;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: isIterableCampaignActive ? "active-iterable-campaign" : "",
        sx: {
            "&.active-iterable-campaign": {
                minHeight: {
                    xs: "54px",
                    sm: "32px"
                },
                bgcolor: "background.accent.accent1",
                display: "flex",
                alignItems: "center"
            }
        }
    }, slotProps === null || slotProps === void 0 ? void 0 : slotProps.bannerContainer), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* IterableEmbeddedSlot */.bD, {
            placementId: Number(placementId),
            renderer: dist/* IterableEmbeddedRenderers.IterableSimpleBanner */.uG.o,
            onRender: function(message) {
                (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.iterableAssetViewed */.Sj.iterableAssetViewed, {
                    data: (0,_object_spread/* default */.Z)({}, getIterableAmplitudeData(message))
                });
            },
            onCTAClick: function(message) {
                (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.iterableAssetClicked */.Sj.iterableAssetClicked, {
                    data: (0,_object_spread/* default */.Z)({}, getIterableAmplitudeData(message))
                });
            }
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/common/IterableBannerSection.tsx



var IterableBannerSection = function() {
    var placementId = (0,IterableWrapper/* useIterablePlacementId */.d)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IterableBanner, {
        placementId: placementId
    });
};


/***/ }),

/***/ 35472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ BackgroundCheckTrustBadge; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46045);
/* harmony import */ var _care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(56925);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69417);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(93946);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(883);
/* harmony import */ var _components_SafetyModalWrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6150);
/* harmony import */ var _components_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19147);







var BackgroundCheckTrustBadge = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), openModal = ref[0], setOpenModal = ref[1];
    var isSmallViewport = (0,_components_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_4__/* .useResponsive */ .F)().isSmallViewport;
    var handleLearnMoreClick = function() {
        setOpenModal(true);
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .AmplitudeEvent.ctaInteracted */ .Sj.ctaInteracted, {
            cta_text: "Learn more"
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        sx: {
            display: "flex",
            alignItems: "center",
            justifyContent: {
                xs: "center",
                sm: "flex-start"
            },
            overflow: {
                sm: "visible"
            }
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                sx: {
                    mr: {
                        xs: 1,
                        sm: 0
                    }
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                variant: isSmallViewport ? "h5" : "h4",
                whiteSpace: {
                    sm: "nowrap"
                },
                children: "All caregivers with this badge are background checked."
            }),
            !isSmallViewport && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                variant: "text",
                component: "button",
                onClick: handleLearnMoreClick,
                sx: {
                    ml: {
                        sm: 1.5,
                        md: 1
                    },
                    textDecoration: "underline",
                    whiteSpace: "nowrap"
                },
                children: "Learn more"
            }),
            isSmallViewport && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                "aria-label": "Learn more",
                onClick: handleLearnMoreClick,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SafetyModalWrapper__WEBPACK_IMPORTED_MODULE_3__/* .SafetyModalWrapper */ .S, {
                openModal: openModal,
                setOpenModal: setOpenModal
            })
        ]
    });
};


/***/ }),

/***/ 87726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ ItemListSchema; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var ItemListSchema = function(param) {
    var searchResultType = param.searchResultType, caregiverSearchResults = param.caregiverSearchResults, jobSearchResults = param.jobSearchResults, totalNumberOfResults = param.totalNumberOfResults, startIndex = param.startIndex;
    var createListItems = function() {
        if (searchResultType === "CAREGIVER") {
            return caregiverSearchResults.map(function(result, index) {
                var ref;
                var caregiverProfile = (ref = result.caregiver.profiles) === null || ref === void 0 ? void 0 : ref.commonCaregiverProfile;
                return {
                    "@type": "WebPage",
                    name: "".concat(result.caregiver.member.displayName, " ").concat(caregiverProfile === null || caregiverProfile === void 0 ? void 0 : caregiverProfile.bio.title),
                    url: "".concat(result.profileURL),
                    position: startIndex + index + 1
                };
            });
        }
        var _jobDetailURL;
        return jobSearchResults.map(function(result, index) {
            return {
                "@type": "ListItem",
                url: (_jobDetailURL = result.jobDetailURL) !== null && _jobDetailURL !== void 0 ? _jobDetailURL : "",
                position: startIndex + index + 1
            };
        });
    };
    var itemList = {
        "@context": {
            "@vocab": "https://schema.org/"
        },
        "@type": "ItemList",
        numberOfItems: totalNumberOfResults,
        itemListElement: createListItems()
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
        "data-testid": "itemListSchema",
        type: "application/ld+json",
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(itemList)
        }
    });
};


/***/ }),

/***/ 44375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ CaregiverCard; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19147);





var CaregiverCardCompact = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9975), __webpack_require__.e(1535), __webpack_require__.e(9814), __webpack_require__.e(1355), __webpack_require__.e(9731)]).then(__webpack_require__.bind(__webpack_require__, 99731));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99731)
            ];
        }
    }
});
var CaregiverCardFull = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9975), __webpack_require__.e(1535), __webpack_require__.e(9814), __webpack_require__.e(1355), __webpack_require__.e(5961)]).then(__webpack_require__.bind(__webpack_require__, 25961));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25961)
            ];
        }
    }
});
var CaregiverCard = function(param) {
    var searchResult = param.searchResult;
    var isSmallViewport = (0,_components_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_2__/* .useResponsive */ .F)().isSmallViewport;
    // Skip profiles without a URL
    if (searchResult.profileURL === null) return null;
    var validSearchResult = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, searchResult), {
        profileURL: searchResult.profileURL
    });
    if (isSmallViewport) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CaregiverCardCompact, {
        searchResult: validSearchResult
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CaregiverCardFull, {
        searchResult: validSearchResult
    });
};


/***/ }),

/***/ 98655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ CaregiverStats; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78462);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70891);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(18987);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69661);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(59334);
/* harmony import */ var _care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13096);
/* harmony import */ var _care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17142);
/* harmony import */ var _care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35690);
/* harmony import */ var _components_contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73739);
/* harmony import */ var _components_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19147);
/* harmony import */ var _context_searchDirectory_SearchDirectoryDataContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32826);
/* harmony import */ var _helpers_narrowSegmentationStats__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21444);







var CaregiverStats = function() {
    var ref = (0,_components_contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_1__/* .usePageAttributes */ .l)(), avgPayRate = ref.avgPayRate, totalNumberOfResults = ref.totalNumberOfResults, segmentNamePluralLowerCase = ref.segmentNamePluralLowerCase;
    var seoSegmentationStats = (0,_context_searchDirectory_SearchDirectoryDataContext__WEBPACK_IMPORTED_MODULE_2__/* .useSearchDirectoryData */ .Q)().seoSegmentationStats;
    var isMediumViewport = (0,_components_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_3__/* .useResponsive */ .F)().isMediumViewport;
    var segmentationStats = (0,_helpers_narrowSegmentationStats__WEBPACK_IMPORTED_MODULE_4__/* .narrowSegmentationStats */ .f)(seoSegmentationStats);
    var ref1;
    var avgReviewRating = (ref1 = segmentationStats === null || segmentationStats === void 0 ? void 0 : segmentationStats.avgReviewRating) !== null && ref1 !== void 0 ? ref1 : null;
    var monthYear = new Date().toLocaleString("default", {
        month: "long",
        year: "numeric"
    });
    var stats = [
        {
            Icon: _care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
            label: "".concat(totalNumberOfResults === null || totalNumberOfResults === void 0 ? void 0 : totalNumberOfResults.toLocaleString(), " ").concat(segmentNamePluralLowerCase, " are listed on Care.com"),
            shouldSkipRender: !!totalNumberOfResults
        },
        {
            Icon: _care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
            label: "The average post rate is ".concat(avgPayRate, "/hr as of ").concat(monthYear),
            shouldSkipRender: !!avgPayRate
        },
        {
            Icon: _care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
            label: "The average star rating for rated ".concat(segmentNamePluralLowerCase, " is ").concat(avgReviewRating === null || avgReviewRating === void 0 ? void 0 : avgReviewRating.toFixed(1)),
            shouldSkipRender: !!avgReviewRating
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        sx: {
            maxWidth: {
                xs: "300px",
                sm: "100%"
            },
            display: {
                xs: "block",
                sm: "flex",
                md: "block"
            },
            mt: {
                xs: 4,
                md: 0
            }
        },
        children: stats.map(function(param) {
            var Icon = param.Icon, label = param.label, shouldSkipRender = param.shouldSkipRender;
            return shouldSkipRender && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                disableGutters: true,
                sx: {
                    py: 0,
                    mx: {
                        xs: 3,
                        sm: 0,
                        md: 0
                    },
                    mt: {
                        xs: 2,
                        sm: 0,
                        md: 2
                    },
                    mr: {
                        xs: undefined,
                        sm: 4,
                        md: undefined
                    },
                    "&:first-of-type": {
                        mt: 0
                    }
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        sx: {
                            mr: {
                                xs: 3,
                                sm: 2,
                                md: 3
                            }
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            sx: {
                                bgcolor: "background.accent.accent3",
                                height: "64px",
                                width: "64px"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
                                size: "48px",
                                color: "text.primary"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        secondaryTypographyProps: {
                            color: "text.primary",
                            variant: isMediumViewport ? "body3" : "body2"
                        },
                        secondary: label
                    })
                ]
            }, label);
        })
    });
};


/***/ }),

/***/ 44514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ shouldShowUserFilters; }
/* harmony export */ });
/* harmony import */ var _generated_globalTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79967);

var shouldShowUserFilters = function(searchingFor, serviceIdForMember) {
    var showPetCareUserFilters = searchingFor === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_0__/* .SEOSegmentationSearchingFor.PROVIDER */ .yh.PROVIDER && serviceIdForMember === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_0__/* .ServiceIdForMember.PET_CARE */ .u2.PET_CARE;
    var showSeniorCareUserFilters = searchingFor === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_0__/* .SEOSegmentationSearchingFor.PROVIDER */ .yh.PROVIDER && serviceIdForMember === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_0__/* .ServiceIdForMember.SENIOR_CARE */ .u2.SENIOR_CARE;
    var showChildCareUserFilters = (searchingFor === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_0__/* .SEOSegmentationSearchingFor.PROVIDER */ .yh.PROVIDER || searchingFor === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_0__/* .SEOSegmentationSearchingFor.ALL_PROVIDER */ .yh.ALL_PROVIDER) && (serviceIdForMember === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_0__/* .ServiceIdForMember.CHILD_CARE */ .u2.CHILD_CARE || serviceIdForMember === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_0__/* .ServiceIdForMember.BABYSITTER */ .u2.BABYSITTER || serviceIdForMember === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_0__/* .ServiceIdForMember.NANNY */ .u2.NANNY);
    var showHomeCareUserFilters = (searchingFor === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_0__/* .SEOSegmentationSearchingFor.PROVIDER */ .yh.PROVIDER || searchingFor === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_0__/* .SEOSegmentationSearchingFor.ALL_PROVIDER */ .yh.ALL_PROVIDER) && serviceIdForMember === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_0__/* .ServiceIdForMember.HOUSEKEEPING */ .u2.HOUSEKEEPING;
    return showPetCareUserFilters || showSeniorCareUserFilters || showChildCareUserFilters || showHomeCareUserFilters;
};


/***/ })

}]);